<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal [customTitle]="(id ? 'Editar' : 'Nueva') + ' plantilla'" (closeFunction)="closeFormFunction()"
    (acceptFunction)="acceptFormFunction()">
    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-4">

        <custom-input [autofocus]="true" label="Código corto" type="text" [formControlItem]="saveForm.get('short_code')">
        </custom-input>

        <div class="flex flex-col gap-1">
            <label class="text-xs font-medium text-gray-600 uppercase tracking-wide">Tipo</label>
            <select formControlName="type"
                class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-300 bg-white">
                @for (opt of typeOptions; track opt.value) {
                <option [value]="opt.value">{{ opt.label }}</option>
                }
            </select>
        </div>

        <custom-input label="Etiqueta" type="text" [formControlItem]="saveForm.get('label')">
        </custom-input>

        <div class="flex flex-col gap-1">
            <label class="text-xs font-medium text-gray-600 uppercase tracking-wide">
                Archivo {{ id ? '(dejar vacío para conservar el actual)' : '*' }}
            </label>

            @if(id && template?.path){
            <p class="text-xs text-gray-400 italic mb-1">Actual: {{ template.path }}</p>
            }

            <label
                class="flex flex-col items-center justify-center w-full h-28 border-2 border-dashed rounded-lg cursor-pointer transition-colors"
                [class.border-indigo-300]="selectedFile"
                [class.bg-indigo-50]="selectedFile"
                [class.border-gray-200]="!selectedFile"
                [class.bg-gray-50]="!selectedFile"
                [class.hover:bg-gray-100]="!selectedFile">
                <input type="file" class="hidden" (change)="onFileChange($event)" />
                @if(selectedFile){
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-indigo-400 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span class="text-xs font-medium text-indigo-600 text-center px-2 truncate max-w-full">{{ selectedFile.name }}</span>
                <span class="text-xs text-gray-400">{{ (selectedFile.size / 1024).toFixed(1) }} KB</span>
                } @else {
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-300 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                </svg>
                <span class="text-xs text-gray-400">Haz clic para seleccionar un archivo</span>
                }
            </label>

            @if(fileError){
            <p class="text-xs text-red-500">{{ fileError }}</p>
            }
        </div>

        <div class="flex items-center gap-3">
            <input type="checkbox" formControlName="is_active" id="is_active"
                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" />
            <label for="is_active" class="text-sm text-gray-600 cursor-pointer">Activa</label>
        </div>

    </form>
</app-custom-modal>
}
